import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import copy from 'clipboard-copy'
import marked from 'marked'
import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Input, Button } from 'reactstrap'
import { useSelectOnFocus } from 'web/hooks/useSelectOnFocus'
import { ModalActions } from 'web/redux/slices/modal-slice'

export const ShareFightTab: FC<{
    fightAndSetupString?: string
    fightOnlyString: string
}> = ({ fightAndSetupString, fightOnlyString }) => {

    const gistAccessToken = window.localStorage.getItem('gist-api-key')
    const [uploading, setUploading] = useState(false)

    const [ref1, onFocus1] = useSelectOnFocus()
    const [ref2, onFocus2] = useSelectOnFocus()

    const disp = useDispatch()

    return (
        <div className="d-flex flex-column">

            {fightAndSetupString != null &&
                <>
                    <div
                        className="markdown small"
                        dangerouslySetInnerHTML={{
                            __html: marked(`
                                Copy this string if you want to share the **fight** outline, as well as the currently **selected setup**.
                            `.trim())
                        }}
                    />

                    <div className="mb-4 d-flex space-mx-2 align-items-end">
                        <Input
                            innerRef={ref1}
                            onFocus={onFocus1}
                            bsSize="sm"
                            className="mt-2"
                            type="text"
                            readOnly={true}
                            value={fightAndSetupString}
                            style={{
                                fontFamily: "monospace",
                                fontSize: "14px",
                            }}
                        />

                        <Button
                            size="sm"
                            outline
                            className="px-3 flex-shrink-0"
                            onClick={() => copy(fightAndSetupString)}
                        >
                            {"Copy"}
                        </Button>

                        {(gistAccessToken != null) && (
                            <Button
                                size="sm"
                                color='dark'
                                className="px-3 flex-shrink-0"
                                onClick={async () => {
                                    setUploading(true)
                                    const response = await axios.post<{ id: string }>(
                                        'https://api.github.com/gists',
                                        {
                                            /**
                                             * Hello future me, this
                                             * does NOT mean the
                                             * consumer needs their
                                             * own API key to access
                                             * the gist.
                                             *
                                             * It only means the gist
                                             * is hidden in the UI, it
                                             * can still be accessed
                                             * by URL by anyone.
                                             */
                                            "public": false,
                                            "files": {
                                                // Empty name on purpose
                                                "": { "content": fightAndSetupString }
                                            }
                                        },
                                        {
                                            headers: {
                                                'Authorization': `token ${gistAccessToken}`,
                                                'Content-Type': 'application/json'
                                            },
                                        }
                                    ).then(result => result.data)

                                    setUploading(false)
                                    const gistUser = window.localStorage.getItem('gist-user')

                                    copy(`${window.location.origin}${window.location.pathname}#${gistUser};${response.id}`)
                                }}
                            >
                                {"Gist share"}
                                {uploading && (
                                    <FontAwesomeIcon className="ml-1" icon={faCircleNotch} spin />
                                )}
                            </Button>
                        )}

                        <Button
                            size="sm"
                            color='dark'
                            className="px-3 flex-shrink-0"
                            onClick={() => {
                                disp(ModalActions.openSetupGistModal({}))
                            }}
                        >
                            {'Gist setup'}
                        </Button>
                    </div>
                </>
            }

            <div
                className="markdown small"
                dangerouslySetInnerHTML={{
                    __html: marked(`
                    Copy this string if you only want to share the **fight** outline.
                `.trim())
                }}
            />

            <div className="mb-4 d-flex space-mx-2 align-items-end">
                <Input
                    innerRef={ref2}
                    onFocus={onFocus2}
                    bsSize="sm"
                    className="mt-2"
                    type="text"
                    readOnly={true}
                    value={fightOnlyString}
                    style={{
                        fontFamily: "monospace",
                        fontSize: "14px",
                    }}
                />

                <Button
                    size="sm"
                    outline
                    className="px-3 flex-shrink-0"
                    onClick={() => copy(fightOnlyString)}
                >
                    {"Copy"}
                </Button>
            </div>

            <div>
                <p className="m-0 small text-muted">
                    <b>{"Tip: "}</b>
                    {"Share your string by uploading it to a service like "}
                    <a href="https://www.pastery.net/" target="_blank" rel="noopener noreferrer">{"pastery.net"}</a>
                    {" or "}
                    <a href="https://pastebin.com/" target="_blank" rel="noopener noreferrer">{"pastebin.com"}</a>
                </p>
            </div>
        </div>
    )
}
